import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import { SiTrackGrid } from "../../../../components/si-track-grid/si-track-grid";
import { GridColumnConfig, GridPreference } from "../../../../models/gridCoumnConfig";
import { UserPermissionName } from "../../../../models/user-permission-name";
import { useLoadData } from "../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../models/api-response";
import { gridApiKeyStore } from "../../../../api/grid-api-key-store";
import { useSaveData } from "../../../../hooks/useSaveData";
import { useEffect, useState } from "react";
import { State } from "@progress/kendo-data-query";
import useDebounce from "../../../../hooks/use-debounce";

interface AssignedServiceInspection {
    userAssignableServices: any;
    isLoading: boolean;
}

export const assignedServiceColumns: GridColumnConfig[] = [
    {
        title: 'Service Name',
        field: 'serviceName',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Service Code',
        field: 'serviceCode',
        filter: 'text',
        searchable: true,
    },
];

export const AssignedServiceInspection = ({ userAssignableServices, isLoading }: AssignedServiceInspection) => {

    // -------------------------------------------------Grid Layout------------------------------

    const {
        isLoading: isLoadingGridLayout,
        data: gridLayouts,
        refetch: refetchGridLayout,
    } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('AssignedService', 'AssignedService'));

    const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
    const [gridConfig, setGridConfig] = useState<{
        dataState: State | undefined;
        columns: any[] | undefined;
    }>();

    const [filteredAssignedServices, setFilteredAssignedServices] = useState<any[]>([]);

    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 300);

    useEffect(() => {
        const filteredAssignedServiceList = userAssignableServices?.filter((AssignedService: any) =>
            Object.values(AssignedService).some(
                (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
            )
        );
        setFilteredAssignedServices(filteredAssignedServiceList || []);
    }, [debouncedSearchTerm, userAssignableServices]);

    const handleInputChange = (value: string) => {
        setSearchTerm(value);
    };

    const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
        const data = {
            filterJSON: JSON.stringify(gridDataState),
            columnJSON: JSON.stringify(gridColumns),
            gridName: 'AssignedService',
            pageName: 'AssignedService',
        };

        mutateAsync({ data }).then(() => {
            refetchGridLayout();
        });
    };

    const handleResetLayout = () => {
        const data = {
            filterJSON: null,
            columnJSON: null,
            gridName: 'AssignedService',
            pageName: 'AssignedService',
        };

        mutateAsync({ data }).then(() => {
            refetchGridLayout();
        });
    };

    useEffect(() => {
        if (!gridLayouts?.data) return;

        try {
            const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

            const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

            // if (filterData && columnJson) {
            setGridConfig({
                columns: columnJson,
                dataState: filterData,
            });
            // }
        } catch (error) {
            console.log('Error parsing grid layout JSON:', error);
        }
    }, [gridLayouts?.data]);

    // ----------------------------------------------------------------------------------------

    return (
        <Card elevation={0} className="">
            <CardHeader
                className="subHead"
                title={
                    <Typography variant="h3" color="textPrimary">
                        Assignable Inspections
                    </Typography>
                }
            />
            <CardContent className="formContainer">
                <Grid container spacing={2}>
                    <Grid item lg={12} sm={12} xl={12} xs={12} display={'flex'} flexDirection={'column'}>
                        <label>Available Services:&nbsp;</label>
                        {/* <strong>-</strong> */}
                    </Grid>
                    <Grid item lg={12} sm={12} xl={12} xs={12}>
                        <SiTrackGrid
                            fileTitle='assigned_service_inspection'
                            columns={assignedServiceColumns}
                            dataItemKey="serviceID"
                            actionPermissions={{
                                export: UserPermissionName.DOWNLOAD_GRID,
                            }}
                            // currentPageSize={10}
                            isBusy={isLoading || isLoadingGridLayout}

                            // -----------------Grid Layout-------
                            dataItems={filteredAssignedServices || []}
                            reorderable
                            handleSearch={handleInputChange}
                            handleSaveLayout={handleSaveLayout}
                            isSaveLayout={true}
                            gridConfigFromApi={gridConfig}
                            handleResetLayout={handleResetLayout}
                            reFixPageNumber
                        // -----------------Grid Layout-------
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}